import { useNavigate } from "react-router-dom";

const TestActionsModal = ({ isOpen, onClose, homework }) => {
    const navigate = useNavigate();

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-4 rounded-md shadow-lg z-50">
                <h2 className="text-lg font-semibold mb-2">Действия с домашним заданием</h2>
                <p>{homework.title?.trim() ? homework.title : "Без названия"}</p>
                <div className="flex gap-2 mt-4">
                    <button
                        className="bg-green-500 text-white px-4 py-2 rounded"
                        onClick={() => {
                            onClose(); // Закрываем модалку перед переходом
                            navigate(`/teachers-cabinet/homeworks/${homework.id}/edit`);
                        }}
                    >
                        Редактировать
                    </button>
                    <button className="bg-red-500 text-white px-4 py-2 rounded">Удалить</button>
                    <button className="bg-gray-400 text-white px-4 py-2 rounded" onClick={onClose}>
                        Закрыть
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TestActionsModal;
